import { sendRequest } from "@api/clients/axios";
import ForwardToInboxIcon from "@mui/icons-material/ForwardToInbox";
import LoadingButton from "@mui/lab/LoadingButton";
import { Box } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

type Props = {
  id: string;
};

function SendTrackingInfoButton({ id }: Props) {
  const { t } = useTranslation();
  const [loading, setLoading] = React.useState(false);
  const handleClick = async () => {
    setLoading(true);
    try {
      const res = await sendRequest("post", `delivery/sendTrackingUrl/${id}`);
      if (res.status === 201) {
        toast("Mail et sms envoyés avec succès", {
          position: "bottom-right",
          type: "success",
        });
      }
    } catch (_error) {
    } finally {
      setLoading(false);
    }
  };
  return (
    <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
      <LoadingButton
        loading={loading}
        loadingPosition="start"
        startIcon={<ForwardToInboxIcon />}
        variant="outlined"
        onClick={() => void handleClick()}
      >
        {t("common.shared.resend-email-sms-tracking")}
      </LoadingButton>
    </Box>
  );
}

export default SendTrackingInfoButton;
